"use client";
import {
  Box,
  BoxProps,
  Button,
  Heading,
  Stack,
  StackProps,
  ThemeTypings,
} from "@chakra-ui/react";
import { Gcms_Button, Gcms_ContentPosition } from "lib/cms-typings";
import { SectionTemplate } from "./section-template";
import { ReactNode } from "react";
import { useRouter } from "next/navigation";

const flexStyles: { [key: string]: Partial<StackProps> } = {
  RIGHT: {
    direction: {
      base: "column",
      lg: "row",
    },
    spacing: {
      lg: "8%",
      xl: "10%",
    },
  },
  LEFT: {
    direction: {
      base: "column",
      lg: "row-reverse",
    },
    spacing: {
      lg: "8%",
      xl: "10%",
    },
  },
  CENTER: {
    direction: {
      base: "column",
    },
    alignItems: "center",
    justifyContent: "center",
  },
};

const copyStyles: { [key in Gcms_ContentPosition]: Partial<BoxProps> } = {
  CENTER: {
    w: "100%",
  },
  RIGHT: {
    w: {
      base: "80%",
      lg: "47%",
    },
    alignSelf: "center",
    textAlign: {
      base: "center",
      lg: "left",
    },
  },
  LEFT: {
    w: {
      base: "80%",
      lg: "47%",
    },
    alignSelf: "center",
    textAlign: {
      base: "center",
      lg: "left",
    },
  },
};

const playerStyles: { [key in Gcms_ContentPosition]: Partial<BoxProps> } = {
  CENTER: {
    w: "100%",
  },
  RIGHT: {
    w: {
      base: "90%",
      lg: "full",
    },
    alignSelf: "center",
  },
  LEFT: {
    w: {
      base: "90%",
      lg: "full",
    },
    alignSelf: "center",
  },
};

export interface PodcastPlayerSectionProps {
  title: string;
  backgroundColor: string;
  textColor: string;
  button: Gcms_Button;
  podcastPlayerPosition: Gcms_ContentPosition;
  children?: ReactNode;
}

const PodcastPlayerSection = ({
  title,
  backgroundColor,
  textColor,
  button,
  podcastPlayerPosition: podPos,
  children,
}: PodcastPlayerSectionProps) => {
  const router = useRouter();
  return (
    <SectionTemplate
      {...{
        bg: backgroundColor,
        color: textColor,
        textAlign: "left",
        from: "news-room",
      }}
    >
      <Stack
        maxW={{ base: "xl", md: "7xl" }}
        mx="auto"
        px={{ base: "6", lg: "20", xl: "10" }}
        {...flexStyles[podPos]}
      >
        <Box
          {...copyStyles[podPos]}
          w={{
            lg: "60%",
          }}
        >
          <Heading
            size="2xl"
            letterSpacing="tight"
            mb="4"
            fontWeight="extrabold"
            lineHeight="normal"
          >
            {title}
          </Heading>
          {children && <Box fontSize="lg">{children}</Box>}
          <Button
            onClick={() => router.push(`${button.href}`)}
            colorScheme={button.theme as ThemeTypings["colorSchemes"]}
            fontSize={{
              base: "auto",
              lg: "lg",
            }}
            w={{
              base: "auto",
            }}
            my={{
              base: 5,
              lg: 8,
            }}
            borderRadius={"full"}
          >
            {button.label}
          </Button>
        </Box>
        <Box
          pt={{
            base: "5",
            lg: 0,
          }}
          {...playerStyles[podPos]}
          justifySelf="center"
        >
          <iframe
            title="Climate Clear Podcast Player"
            src="https://share.transistor.fm/e/climate-clear/playlist"
            width="100%"
            height="360"
            seamless
          />
        </Box>
      </Stack>
    </SectionTemplate>
  );
};

export default PodcastPlayerSection;
